type Address = {
  streetNumberAndName: string
  apartmentNumber: string
  city: string
  zipCode: string
  state: string
  country: string
}
export function getAddressString(address?: Address) {
  return address
    ? `${address.apartmentNumber ? address.apartmentNumber : " "}${address.streetNumberAndName}, ${
        address.zipCode
      } ${address.state}, ${address.country}`
    : ""
}
